"use client"

import { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

type Props = {
  data: {
    playlistImages?: string[]
    artistImgUrl: string
    artistBio: string
  }
}

export default function PlaylistFooter({ data }: Props) {
  const images = data.playlistImages ?? []
  const hasImages = images.length > 0

  const [index, setIndex] = useState(0)

  /* ================= AUTOPLAY ================= */
  useEffect(() => {
    if (!hasImages) return

    const interval = setInterval(() => {
      setIndex(i => (i + 1) % images.length)
    }, 4000)

    return () => clearInterval(interval)
  }, [images.length, hasImages])

  const currentImage = images[index]

  return (
    <div
      className="
        flex flex-col items-center gap-4
        px-4 mt-4 mb-4
      "
    >
      {/* ================= CAROUSEL (FRAMER MOTION) ================= */}
      {hasImages && (
        <div
          className="
            relative
            w-full max-w-[500px]
            aspect-square
            overflow-hidden
            rounded-2xl
            border border-white/10
            active:scale-95 transition-transform
          "
        >
          <AnimatePresence mode="wait">
            <motion.img
              key={currentImage}
              src={currentImage}
              alt="Playlist slide"
              className="absolute inset-0 w-full h-full object-cover rounded-2xl"
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            />
          </AnimatePresence>
        </div>
      )}

      {/* ================= ARTIST ================= */}
      <div
        className="
          flex items-center justify-between gap-4
          px-2 py-2
          rounded-full
          bg-neutral-900
          border border-white/10
          transition-all active:scale-95
        "
      >
        {/* ARTIST IMAGE */}
        <figure
          className="
            w-9 h-9 ml-3
            overflow-hidden rounded-full
          "
        >
          <img
            src={data.artistImgUrl}
            alt="Artist"
            className="w-full h-full object-cover"
          />
        </figure>

        {/* FOLLOW BUTTON */}
        <a
          href={data.artistBio}
          target="_blank"
          rel="noopener noreferrer"
          className="
            px-5 py-2
            rounded-full
            bg-white text-black
            text-sm font-medium
            transition hover:opacity-80 active:scale-95
          "
        >
          Seguir
        </a>
      </div>
    </div>
  )
}
